import PropTypes from "prop-types";

const SocialLogin = ({ className = "" }) => {
  return (
    <section
      className={`self-stretch flex flex-col items-center justify-center pt-0 px-5 pb-12 text-center text-base text-light-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="text-gray-500">Đăng nhập qua</div>

        <div className="flex flex-row items-center justify-center gap-6">
          {/* Ẩn Google Login vì chưa cấu hình OAuth Capacitor */}
          <img
            className="w-10 h-10 opacity-50"
            alt="Google"
            src="/group-1.svg"
            title="Sắp ra mắt"
          />
          {/* Ẩn Facebook Login */}
          <img
            className="w-10 h-10 opacity-50"
            alt="Facebook"
            src="/group-2.svg"
            title="Sắp ra mắt"
          />
          {/* Ẩn Apple Login */}
          <img
            className="w-10 h-10 opacity-50"
            alt="Apple"
            src="/group-3.svg"
            title="Sắp ra mắt"
          />
        </div>
      </div>
    </section>
  );
};

SocialLogin.propTypes = {
  className: PropTypes.string,
};

export default SocialLogin;